import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  count: 0,
  active: false,
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    decrement(state) {
      state.count--;

      if (state.count < 1) {
        if (state.count < 0) {
          state.count = 0;
        }
        
        state.active = false;
      }
    },
    increment(state) {
      state.count++;
      state.active = true;
    },
  },
});

export const loadingActions = loadingSlice.actions;

export default loadingSlice.reducer;
